import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useAuthContext } from 'hooks/useAuthContext';


const AuthRoute = ({ component: Component, path, scope, exact=false }) => {
  const { role } = useAuthContext();
  const isAuthed = () => role.check(scope, "read");
  return (
    role &&
    <Route
      exact={exact}
      path={path}
			render={(props) =>
				isAuthed() ? (
					<Component {...props} />
				) : (
					<Redirect
						to={{
							pathname: '/unauthorized'
						}}
					/>
				)
			}
    />
  )
}

AuthRoute.propTypes = {
  Component: PropTypes.node,
  path: PropTypes.string,
  scope: PropTypes.string,
  exact: PropTypes.bool
}

AuthRoute.defaultProps = {
  Component: (<div>unknown</div>),
  path: '/unauthorized',
  scope: '',
  exact: false
}

export default AuthRoute;